import { createPortal, useRef } from 'preact/compat'
import Icon from '@/components/snippets/icon/icon'

export const SearchHeader = ({ query, totalResults, isLoading, corrections, results }) => {
  const searchHeader = document.querySelector('#search-results')
  const content = useRef(searchHeader ? searchHeader.innerHTML : '')
  const hasMounted = useRef(false)

  const resultsReady = !isLoading && Array.isArray(results?.results)

  if (!searchHeader) {
    return null
  }

  if (!hasMounted.current) {
    hasMounted.current = true
    searchHeader.innerHTML = ''
  }

  const focusSearch = (containerId) => {
    const searchContainer = document.querySelector(`#${containerId} input[name="query"]`)
    if (searchContainer) {
      setTimeout(() => {
        searchContainer.focus()
      }, 100)
    }
  }

  return createPortal(
    resultsReady && (
      <div className="flex flex-col md:justify-center gap-x-gutter gap-y-1 w-full items-center" data-results={totalResults}>
          <div className="flex items-center justify-between gap-x-1 w-full lg:justify-center lg-max:py-0.875 lg-max:border-b border-b-borders-default px-margin">
            <h2 className="heading-m lg:heading-xl font-light font-serif flex-1 text-left lg:text-center lg:w-full">
                {totalResults === 0 ? 'No' : totalResults} Results For "{corrections?.corrected ? corrections?.corrected : query}"
            </h2>
            <filter-toggle class="contents lg:hidden">
              <button className="flex items-center gap-x-0.5 w-fit flex-shrink-0" aria-label="Toggle Filters">
                <span className="text-xs text-type-black-primary font-medium uppercase">Filter & Sort</span>
                <Icon id="plus" className="size-[14px]" />
              </button>
            </filter-toggle>
          </div>
          <div className="px-margin w-full flex flex-col gap-y-1 justify-center items-center">
          {corrections?.corrected && (
              <div className="paragraph-xs">
                  <p>No results found for "{query}". Showing results for "{corrections.corrected}" instead.</p>
              </div>
          )}
          {corrections?.didYouMean && (
              <div className="paragraph-xs">
                  <p>Did you mean: <a href={`/search?query=${corrections.didYouMean}`} className='link-fade' aria-label={`Search for ${corrections.didYouMean}`}>{corrections.didYouMean}</a></p>
              </div>
          )}
          {totalResults === 0 && (
              <div className={'[&>div]:!block'} dangerouslySetInnerHTML={{ __html: content.current }} />
          )}
          <x-button class="border border-borders-default py-0.875 px-1.5 rounded-full flex flex-row gap-x-1 text-type-black-secondary w-full lg:w-fit min-w-sm max-w-full" data-modal-parent="quick-search" data-modal-role="open" aria-label="Search again..." onClick={() => focusSearch('quick-search')}>
            <div className="flex size-[14px] children:size-full">
              <Icon id="magnifying-glass" />
            </div>
            <span className="paragraph-s text-type-black-secondary">Search Again</span>
          </x-button>
          </div>
      </div>
    ), searchHeader
  )
}
